import deserialize from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    list: [],
    item: null
  },

  getters: {
    currentKickstarterBacker: (state) => state.item
  },

  mutations: {
    kickstarterBackerFetched(state, { kickstarterBacker }) {
      state.item = kickstarterBacker
    },

    resetState(state) {
      state.list = []
      state.item = null
    }
  },

  actions: {
    fetchKickstarterBacker({ commit }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/kickstarter-backer`
        })
          .then((response) => {
            deserialize(response.data).then((kickstarterBacker) => {
              commit('kickstarterBackerFetched', { kickstarterBacker })
              resolve()
            })
          })
          .catch((error) => {
            error.response.status === 404 ? resolve() : reject()
          })
      })
    }
  }
}
